import React from 'react';
import { useExchangeRates } from '../../../hooks/useExchangeRates';
import { HistoricalRate } from '../rates/HistoricalRate';
import { LoadingSpinner } from '../../shared/LoadingSpinner';

const BASE_RATES = {
  USD: { rate: 21.89, year: 1997 },
  EUR: { rate: 22.07, year: 1997 },
  GBP: { rate: 35.37, year: 1997 }
};

export function HistoricalSection() {
  const { data: currentRates, isLoading } = useExchangeRates();

  if (isLoading) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-8">
        <div className="flex justify-center">
          <LoadingSpinner />
        </div>
      </div>
    );
  }

  const historicalData = currentRates?.filter(rate => 
    ['USD', 'EUR', 'GBP'].includes(rate.fromCurrency)
  ).map(rate => {
    const baseRate = BASE_RATES[rate.fromCurrency as keyof typeof BASE_RATES];
    const percentageChange = ((rate.rate - baseRate.rate) / baseRate.rate) * 100;

    return {
      pair: `${rate.fromCurrency}/NGN`,
      oldRate: baseRate.rate,
      currentRate: rate.rate,
      percentageChange,
      year: baseRate.year
    };
  });

  return (
    <div className="bg-white rounded-xl shadow-lg p-8">
      <div className="mb-6">
        <h2 className="text-2xl font-bold mb-2">28 Years Historical Data</h2>
        <p className="text-gray-600">
          Historical Dollar to Naira black market rate and CBN official exchange rate Nigeria from 1997 to present
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {historicalData?.map((currency) => (
          <HistoricalRate
            key={currency.pair}
            pair={currency.pair}
            oldRate={currency.oldRate}
            currentRate={currency.currentRate}
            percentageChange={currency.percentageChange}
            year={currency.year}
          />
        ))}
      </div>

    </div>
  );
}